import { Injectable } from '@angular/core';

import { GameBase } from './game-base';
import { ClassicGameFlow } from './game-flows/classic-game-flow';
import { OpenGameFlow } from './game-flows/open-game-flow';
import { ThreeHeadedDragonFlow } from './game-flows/three-headed-dragon-flow';
import { BaccaratGame } from './main-games/baccarat/baccarat-game';
import { DragonTigerGame } from './main-games/dragon-tiger/dragon-tiger-game';
import { ThreeHeadedDragonGame } from './main-games/three-headed-dragon/three-headed-dragon-game';
import { GameType } from '../models/communication/app-enums.model';
import { InitialTableState } from '../models/communication/app-state.model';

class Baccarat extends BaccaratGame {
    override flow: ClassicGameFlow = new ClassicGameFlow(this);
}

class OpenBaccarat extends BaccaratGame {
    override flow: OpenGameFlow = new OpenGameFlow(this);
}

class DragonTiger extends DragonTigerGame {
    override flow: ClassicGameFlow = new ClassicGameFlow(this);
}

class OpenDragonTiger extends DragonTigerGame {
    override flow: OpenGameFlow = new OpenGameFlow(this);
}

class ThreeHeadedDragon extends ThreeHeadedDragonGame {
    override flow: ThreeHeadedDragonFlow = new ThreeHeadedDragonFlow(this);
}

/**
 * Responsible for defining all the different game combinations.
 * It exposes a single method that returns a `GameBase` subclass instance
 * based on a provided `GameType`.
 */
@Injectable({
    providedIn: 'root'
})
export class GameFactory {
    create(gameType: GameType, initialData?: InitialTableState): GameBase {
        switch (gameType) {
            case GameType.Baccarat:
                return new Baccarat(initialData);
            case GameType.OpenBaccarat:
                return new OpenBaccarat(initialData);
            case GameType.DragonTiger:
                return new DragonTiger(initialData);
            case GameType.OpenDragonTiger:
                return new OpenDragonTiger(initialData);
            case GameType.ThreeHeadedDragon:
                return new ThreeHeadedDragon(initialData);
            default:
                throw new Error('Invalid game type!');
        }
    }
}
